<template lang="pug">
  .table-pagination
    .pages
      .page.page-previous(@click.stop.prevent="onPreviousPage") «
      .page(v-for="page in pages" 
            :class="pageClasses(page)" v-html="page" @click.stop.prevent="setPage(page)")
      .page.page--next(@click.stop.prevent="onNextPage") »
</template>

<script>
export default {
  name: 'table-pagination',
  props: [ 'page', 'totalPages' ],
  methods: {
    setPage (page) {
      page = Math.max(Math.min(page, this.totalPages), 1)
      this.$emit('setPage', page)
    },
    onNextPage () {
      this.setPage(this.page + 1)
    },
    onPreviousPage () {
      this.setPage(this.page - 1)
    },
    pageClasses (page) {
      if (page === this.page) {
        return 'page-current'
      }
      return ''
    }
  },
  computed: {
    pages ({page, totalPages}) {
      let pages = []
      let offset = 2
      let start = page - offset
      const right = totalPages - Math.max(page, totalPages - offset)
      let end = page + offset - right 

      if (start > 1) {
        for (let i = 1; i < Math.min(offset + 1, start); ++i) {
          start += 1
          pages.push(i)
        }
      }

      for (let i = start; i <= page; ++i) {
        if (i > 0 && i <= totalPages) {
          pages.push(i)
        }
      }

      for (let i = page + 1; i <= end; ++i) {
        if (i > 0 && i <= totalPages) {
          pages.push(i)
        }
      }

      if (end < totalPages) {
        for (let i = totalPages - right + 1; i <= totalPages; ++i) {
          pages.push(i)
        }
      }

      return pages
    }
  }
}
</script>

<style lang="stylus" scoped>
.pages {
  margin: .5em 0
}

.pages .page {
  cursor: pointer
  display: inline-block
  padding: .5em .25em
  margin: 0
  color: #999
  width: 1.7em
  text-align: center
  box-sizing: border-box
}

.pages .page.page-current {
  color: #000
}

</style>



// WEBPACK FOOTER //
// table-pagination.vue?293a5691